module.exports = require("./mgo-CM.js");